import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { Config } from '../config';
import 'primereact/resources/themes/nova/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

class CustomPalette extends Component {

    constructor(props) {
        super(props);

        this.state = { newRow: null, currentDestination: null, currentSelection: null, emptyCriterion: null, emptyKpi: null, criteria: [], kpis: [], displayDialogCriterion: false, displayDialogKpi: false, guiText: [] };
        this.saveCriterion = this.saveCriterion.bind(this);
        this.saveKpi = this.saveKpi.bind(this);
        this.addNewCriterionRow = this.addNewCriterionRow.bind(this);
        this.addNewKpiRow = this.addNewKpiRow.bind(this);
        this.deleteSelectedCriterion = this.deleteSelectedCriterion.bind(this);
        this.deleteSelectedKpi = this.deleteSelectedKpi.bind(this);
        this.onCriterionSelect = this.onCriterionSelect.bind(this);
        this.onKpiSelect = this.onKpiSelect.bind(this);

        this.destinations = []

    }


    componentDidMount() {
        this.setState({
            criteria: JSON.parse(this.props.criteria),
            kpis: JSON.parse(this.props.kpis),
            emptyCriterion: { 'criterion_id': 'empty_criterion', 'criterion_brief_description': 'Empty criterion brief description', 'criterion_long_description': 'Empty criterion long description', 'criterion_destination': 'SG' },
            emptyKpi: { 'kpi_id': 'empty_kpi', 'criterion_id': 'empty_criterion', 'kpi_brief_description': 'Empty KPI brief description', 'kpi_long_description': 'Empty KPI long description', 'assessed_manually': true, 'kpi_destination': 'SG' },
        });

        this.destinations = [{ 'label': 'Smart grid', 'value': 'SG' }, { 'label': 'Externality', 'value': 'EXT' }];

        this.fetchGuiText();

    }

    fetchGuiText() {
        fetch(Config.api.getTranslatedStrings)
            .then(response => {
                response.json().then(json => {
                    this.setState({ guiText: json.data });
                });
            })
            .catch(error => this.setState({ error }));
    }

    saveCriterion() {
        let criteria = [...this.state.criteria];
        criteria[this.findSelectedCriterionIndex()] = this.state.newRow;
        this.setState({ criteria: criteria, selectedCriterion: null, newRow: null, currentDestination: null, displayDialogCriterion: false });
    }

    saveKpi() {
        let kpis = [...this.state.kpis];
        kpis[this.findSelectedKpiIndex()] = this.state.newRow;
        this.setState({ kpis: kpis, selectedKpi: null, newRow: null, currentDestination: null, displayDialogKpi: false });
    }

    addNewCriterionRow() {
        let criteria = [...this.state.criteria];
        criteria.push(this.state.emptyCriterion);
        this.setState({ criteria: criteria });
    }

    addNewKpiRow() {
        let kpis = [...this.state.kpis];
        kpis.push(this.state.emptyKpi);
        this.setState({ kpis: kpis });
    }

    deleteSelectedCriterion() {
        let index = this.findSelectedCriterionIndex();
        this.setState({
            criteria: this.state.criteria.filter((val, i) => i !== index),
            selectedCriterion: null,
            newRow: null,
            currentDestination: null,
            displayDialogCriterion: false
        });
    }

    deleteSelectedKpi() {
        let index = this.findSelectedKpiIndex();
        this.setState({
            kpis: this.state.kpis.filter((val, i) => i !== index),
            selectedKpi: null,
            newRow: null,
            currentDestination: null,
            displayDialogKpi: false
        });
    }

    findSelectedCriterionIndex() {
        return this.state.criteria.indexOf(this.state.selectedCriterion);
    }

    findSelectedKpiIndex() {
        return this.state.kpis.indexOf(this.state.selectedKpi);
    }

    updateProperty(property, value) {
        let newRow = this.state.newRow;
        newRow[property] = value;
        this.setState({ newRow: newRow });
    }

    updatePropertyDestination(property, value) {
        let newRow = this.state.newRow;
        newRow[property] = value.value;
        this.setState({ newRow: newRow });
        this.setState({ currentDestination: this.destinations.find(obj => obj.value === value.value) });
    }

    onCriterionSelect(e) {
        this.setState({
            displayDialogCriterion: true,
            newRow: Object.assign({}, e.data),
            currentDestination: this.destinations.find(obj => obj.value === e.data.criterion_destination)
        });
    }

    onKpiSelect(e) {
        this.setState({
            displayDialogKpi: true,
            newRow: Object.assign({}, e.data),
            currentDestination: this.destinations.find(obj => obj.value === e.data.kpi_destination)
        });
    }


    render() {

        

        let footerCriterions = <div className="clearfix" style={{ width: '100%' }}>
            <Button label="Add" icon="pi pi-check" id="button-add-criterion" onClick={this.addNewCriterionRow} />
        </div>;

        let footerKPIs = <div className="clearfix" style={{ width: '100%' }}>
            <Button label="Add" icon="pi pi-check" id="button-add-kpi" onClick={this.addNewKpiRow} />
        </div>;


        let dialogFooterCriterion = <div className="ui-dialog-buttonpane clearfix">
            <Button icon="pi pi-times" label="Delete" onClick={this.deleteSelectedCriterion} />
            {this.state.newRow && <Button label="Save" icon="pi pi-check" onClick={this.saveCriterion} />}
        </div>;

        let dialogFooterKpi = <div className="ui-dialog-buttonpane clearfix">
            <Button icon="pi pi-times" label="Delete" onClick={this.deleteSelectedKpi} />
            {this.state.newRow && <Button label="Save" icon="pi pi-check" onClick={this.saveKpi} />}
        </div>;



        return (
            <div>
                <div className="content-section implementation">

                    <div className="block">
                        <h2>Criteria</h2>
                        <DataTable value={this.state.criteria} paginator={true} rows={10} footer={footerCriterions}
                            selectionMode="single" selection={this.state.selectedCriterion} onSelectionChange={(e) => { this.setState({ selectedCriterion: e.data }); }}
                            onRowSelect={this.onCriterionSelect}>
                            <Column field="criterion_id" header="ID" />
                            <Column field="criterion_brief_description" header="Brief description" />
                            <Column field="criterion_long_description" header="Long description" />
                            <Column field="criterion_destination" header="Branch" />
                        </DataTable>

                        <input name='custom_criteria' type="hidden" value={JSON.stringify(this.state.criteria)} />

                    </div>

                    <div className="block">
                        <h2>KPIs</h2>
                        <DataTable value={this.state.kpis} paginator={true} rows={10} footer={footerKPIs}
                            selectionMode="single" selection={this.state.selectedKpi} onSelectionChange={(e) => { this.setState({ selectedKpi: e.data }); }}
                            onRowSelect={this.onKpiSelect}>
                            <Column field="kpi_id" header="KPI ID" />
                            <Column field="criterion_id" header="Parent Criterion ID" />
                            <Column field="kpi_brief_description" header={this.state.guiText['TABLE_COLUMN_CRITERION_BRIEF_DESCRIPTION']} />
                            <Column field="kpi_long_description" header="Long description" />
                            <Column field="kpi_destination" header="Branch" />
                            <Column field="assessed_manually" header="Maximise" className={'qualitative-col'} body={(rowData) => (<Checkbox checked={JSON.parse(rowData.assessed_manually)} disabled={true} />)} />
                        </DataTable>

                        <input name='custom_kpis' type="hidden" value={JSON.stringify(this.state.kpis)} />

                    </div>


                    <Dialog visible={this.state.displayDialogCriterion} width="600px" header="Criterion details" modal={true} footer={dialogFooterCriterion} onHide={() => this.setState({ displayDialogCriterion: false })}>
                        {this.state.newRow && this.state.displayDialogCriterion &&
                            <div>
                                <div className="row">
                                    <div className="col-sm-4" style={{ padding: '.75em' }}><label htmlFor="criterion_id">ID</label></div>
                                    <div className="col-sm-8" style={{ padding: '.5em' }}>
                                        <InputText id="criterion_id" onChange={(e) => { this.updateProperty('criterion_id', e.target.value) }} value={this.state.newRow.criterion_id} />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-4" style={{ padding: '.75em' }}><label htmlFor="criterion_brief_description">Brief description</label></div>
                                    <div className="col-sm-8" style={{ padding: '.5em' }}>
                                        <InputText id="criterion_brief_description" onChange={(e) => { this.updateProperty('criterion_brief_description', e.target.value) }} value={this.state.newRow.criterion_brief_description} />
                                    </div>
                                </div>


                                <div className="row">
                                    <div className="col-sm-4" style={{ padding: '.75em' }}><label htmlFor="criterion_long_description">Long description</label></div>
                                    <div className="col-sm-8" style={{ padding: '.5em' }}>
                                        <InputText id="criterion_long_description" onChange={(e) => { this.updateProperty('criterion_long_description', e.target.value) }} value={this.state.newRow.criterion_long_description} />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-4" style={{ padding: '.75em' }}><label htmlFor="criterion_destination">Branch</label></div>
                                    <div className="col-sm-8" style={{ padding: '.5em' }}>
                                        <Dropdown
                                            options={this.destinations}
                                            onChange={(e) => { this.updatePropertyDestination('criterion_destination', e.value) }}
                                            value={this.state.currentDestination}
                                            placeholder="Select destination" optionLabel="label" />
                                    </div>
                                </div>

                            </div>
                        }
                    </Dialog>


                    <Dialog visible={this.state.displayDialogKpi} width="600px" header="KPI details" modal={true} footer={dialogFooterKpi} onHide={() => this.setState({ displayDialogKpi: false })}>
                        {this.state.newRow && this.state.displayDialogKpi &&
                            <div>
                                <div className="row">
                                    <div className="col-sm-4" style={{ padding: '.75em' }}><label htmlFor="kpi_id">KPI ID</label></div>
                                    <div className="col-sm-8" style={{ padding: '.5em' }}>
                                        <InputText id="kpi_id" onChange={(e) => { this.updateProperty('kpi_id', e.target.value) }} value={this.state.newRow.kpi_id} />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-4" style={{ padding: '.75em' }}><label htmlFor="criterion_id">Parent Criterion ID</label></div>
                                    <div className="col-sm-8" style={{ padding: '.5em' }}>
                                        <InputText id="criterion_id" onChange={(e) => { this.updateProperty('criterion_id', e.target.value) }} value={this.state.newRow.criterion_id} />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-4" style={{ padding: '.75em' }}><label htmlFor="kpi_brief_description">Brief description</label></div>
                                    <div className="col-sm-8" style={{ padding: '.5em' }}>
                                        <InputText id="kpi_brief_description" onChange={(e) => { this.updateProperty('kpi_brief_description', e.target.value) }} value={this.state.newRow.kpi_brief_description} />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-4" style={{ padding: '.75em' }}><label htmlFor="kpi_long_description">Long description</label></div>
                                    <div className="col-sm-8" style={{ padding: '.5em' }}>
                                        <InputText id="kpi_long_description" onChange={(e) => { this.updateProperty('kpi_long_description', e.target.value) }} value={this.state.newRow.kpi_long_description} />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-4" style={{ padding: '.75em' }}><label htmlFor="kpi_destination">Branch</label></div>
                                    <div className="col-sm-8" style={{ padding: '.5em' }}>
                                        <Dropdown
                                            options={this.destinations}
                                            onChange={(e) => { this.updatePropertyDestination('kpi_destination', e.value) }}
                                            value={this.state.currentDestination}
                                            placeholder="Select destination" optionLabel="label" />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-4" style={{ padding: '.75em' }}><label htmlFor="assessed_manually">Maximise/minimise</label></div>
                                    <div className="col-sm-4" style={{ padding: '.5em' }}>
                                        <Checkbox onChange={(e) => { this.updateProperty('assessed_manually', e.checked) }} checked={JSON.parse(this.state.newRow.assessed_manually)} />
                                    </div>
                                </div>
                            </div>
                        }
                    </Dialog>

                </div>

            </div>
        );
    }
}



export default CustomPalette;